const LocationFrame = ({ selectedLocation }) => {
    if (!selectedLocation) {
        return <div>No location selected</div>;
    }

    const mapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(
        selectedLocation
    )}&output=embed`;

    return (
        <iframe
            src={mapsUrl}
            title="Location Map"
            frameBorder="0"
            style={{ width: '100%', height: '100%' }}
            allowFullScreen
            styles={{
                position: "relative",
                zIndex: "0"
            }}
        ></iframe>
    );
};

export default LocationFrame;
